import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import { useContactsStore } from "@stores/survey/mailing/contacts";
import { useContactAttributesStore } from "@stores/survey/mailing/contactAttributes";

export const useContactTestAttributesStore = defineStore("contactTestAttributes", () => {
  // stores
  const contactsStore = useContactsStore();
  const { selectedContact } = storeToRefs(contactsStore);
  const contactAttributesStore = useContactAttributesStore();
  const { getOpenContactAttributeOptions, getSingleContactAttributeOptions, contactAttributes } =
    storeToRefs(contactAttributesStore);

  const getContactTestAttributes = computed(() => selectedContact.value.custom_attributes?.test_attributes);
  const areAttributesPresent = computed(() => getContactTestAttributes.value?.length > 0);

  const addAttribute = () => getContactTestAttributes.value.push({ key: "", value: [] });
  const removeAttribute = (index) => getContactTestAttributes.value.splice(index, 1);

  const getContactAttributesNameOptions = computed(() =>
    getOpenContactAttributeOptions.value.concat(getSingleContactAttributeOptions.value),
  );
  const updateContactAttributesName = (index, value) => {
    getContactTestAttributes.value[index].key = value;
    restoreContactAttributesValues(index);
  };

  const getContactAttributesValueOptions = computed(() => {
    return Object.fromEntries(
      Object.entries(contactAttributes.value.single || {}).map(([k, v]) => [k, v.map((o) => ({ label: o, value: o }))]),
    );
  });
  const restoreContactAttributesValues = (index) => (getContactTestAttributes.value[index].value = []);
  const updateContactAttributesValue = (index, value) => (getContactTestAttributes.value[index].value = value);

  return {
    getContactTestAttributes,
    areAttributesPresent,
    // items
    addAttribute,
    removeAttribute,
    // name
    getContactAttributesNameOptions,
    updateContactAttributesName,
    // value
    getContactAttributesValueOptions,
    updateContactAttributesValue,
  };
});
